const zoomWrapper = document.getElementById("zoom-container");
  const zoomImg = document.getElementById("main-product-image");
 
  let isZoomed = false;
 
  zoomWrapper.addEventListener("click", () => {
    isZoomed = !isZoomed;
    zoomWrapper.classList.toggle("zoomed", isZoomed);
  });
 
  zoomWrapper.addEventListener("mousemove", (e) => {
    if (!isZoomed) return;
 
    const bounds = zoomWrapper.getBoundingClientRect();
    const x = ((e.clientX - bounds.left) / bounds.width) * 100;
    const y = ((e.clientY - bounds.top) / bounds.height) * 100;
 
    zoomImg.style.transformOrigin = `${x}% ${y}%`;
  });
 
    document.addEventListener("DOMContentLoaded", function () {
      const customQty = document.getElementById("custom-quantity");
    const shopifyQty = document.getElementById("shopify-quantity");
 
    // Sync whenever custom quantity changes
    customQty.addEventListener("input", function () {
      if (shopifyQty) shopifyQty.value = this.value;
    });
 
    // Optional: also sync on + / − buttons
    window.updateQty = function (change) {
      let current = parseInt(customQty.value) || 1;
      const newVal = Math.max(current + change, 1);
      customQty.value = newVal;
      if (shopifyQty) shopifyQty.value = newVal;
    };
      
    const thumbnails = document.querySelectorAll(".thumbnail-image");
    const mainImage = document.getElementById("main-product-image");
 
    thumbnails.forEach(thumb => {
      thumb.addEventListener("click", function () {
        mainImage.setAttribute("src", this.dataset.full);
        thumbnails.forEach(t => t.classList.remove("active"));
        this.classList.add("active");
      });
    });
 
      
  });
 
  function selectVariant(variantId,varientName) {
    document.getElementById('selected-variant-id').value = variantId;
    document.getElementById('color_name').innerHTML = varientName;
  
    // Highlight selected swatch
    document.querySelectorAll('.image-swatch').forEach(el => el.classList.remove('active'));
    const selectedButton = document.querySelector(`.image-swatch[data-variant-id="${variantId}"]`);
    if (selectedButton) selectedButton.classList.add('active');
  
    // Optional: change main image
    
    const selected = variants.find(v => v.id == variantId);
    if (selected && selected.featured_image) {
      document.getElementById("main-product-image").src = selected.featured_image.src;
    }

    
    // Get fake stock
    const fakeStock = getFakeStock(variantId);

    // Width for progress bar
    const width = (fakeStock / 10) * 100 + "%";

    $(".stock_number").text(fakeStock);
    $(".progress-fill").css("width", width);
    
  }

  const fakeStockMap = {};
  function getFakeStock(variantId) {
    if (!fakeStockMap[variantId]) {
      fakeStockMap[variantId] = Math.floor(Math.random() * 7) + 1; // 1–10
    }
    return fakeStockMap[variantId];
  }
 
  
  function updateQty(change) {
    const qtyInput = document.getElementById('custom-quantity');
    let current = parseInt(qtyInput.value) || 1;
    qtyInput.value = Math.max(current + change, 1);
  }
 
  // 🔁 Function to update cart count
// function updateCartCount() {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       const cartIcon = document.getElementById('cart-icon-bubble');
//       if (!cartIcon) return;
 
//       let bubble = cartIcon.querySelector('.cart-count-bubble');
 
//       // Create the bubble if it doesn't exist
//       if (!bubble) {
//         bubble = document.createElement('div');
//         bubble.className = 'cart-count-bubble';
//         bubble.innerHTML = `
//           <span aria-hidden="true">${cart.item_count}</span>
//           <span class="visually-hidden">${cart.item_count} item${cart.item_count === 1 ? '' : 's'}</span>
//         `;
//         cartIcon.appendChild(bubble);
//       } else {
//         // Update the bubble if it exists
//         const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
//         const hiddenSpan = bubble.querySelector('.visually-hidden');
 
//         if (visibleSpan) visibleSpan.textContent = cart.item_count;
//         if (hiddenSpan) hiddenSpan.textContent = `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`;
//       }
 
//       // Hide bubble if empty cart
//       if (cart.item_count === 0) {
//         bubble.style.display = 'none';
//       } else {
//         bubble.style.display = 'inline-block';
//       }
//     })
//     .catch(err => console.error('Failed to fetch cart:', err));
// }

async function addToCart(event) {
  event.preventDefault();

  const form = event.currentTarget;
  const button = form.querySelector(".add-to-cart-btn");

  const qty = parseInt(document.getElementById('custom-quantity').value) || 1;
  const variantId = document.getElementById('selected-variant-id').value;

  if (!variantId) {
    alert("Please select a variant.");
    return;
  }

  // --- Create spinner dynamically ---
  let spinner = button.querySelector(".spinner");
  if (!spinner) {
    spinner = document.createElement("span");
    spinner.className = "spinner";
    button.appendChild(spinner);
  }

  // Show loading state
  button.disabled = true;
  spinner.style.display = "inline-block";

  try {
    // Add to cart
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });

    // Refresh cart drawer
    setTimeout(() => {
      refreshCartDrawer();
    }, 1000);
    

  } catch (err) {
    console.error("Error adding to cart:", err);
    alert("Something went wrong. Please try again.");
  } finally {
    // Hide spinner and re-enable
    button.disabled = false;
    spinner.style.display = "none";
  }
}

function refreshCartDrawer() {
  $('cart-drawer').removeClass('is-empty');
  $('cart-drawer').load(location.href + " #CartDrawer");
  $('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
  // $(".cart-count-bubble").click();
 $("cart-drawer").addClass("active");
}